<template>
<div>
  <div class="col-lg-1"><img class="thumb" src="/static/img/ic-user.png"></div>
                  <div class="col-lg-11"> 
                    <div class="username">{{rating.login}}</div>
                    <div class="rates">
                      <v-rating
          v-model="rating.stars"
          background-color="orange lighten-3"
          color="orange"
          small
          readonly
        ></v-rating>
                    </div>
                    <div class="comment">{{rating.comment}}</div>
  </div>
 </div>  
<!--
  <div class="text-left p-3 mb-5 ">
    <p><span class="font-weight-bold">{{rating.login}}</span> <span v-if="this.$store.state.user.login === rating.login"><i>(you)</i></span> says:</p>
    <v-app style="height: 10px; margin-top: -15px; background: white">
      <div class="text-left">
        <v-rating
          v-model="rating.stars"
          background-color="orange lighten-3"
          color="orange"
          small
          readonly
        ></v-rating>
        <p class="pl-2">{{rating.comment}}</p>
        
        <hr v-if=" ratingIndex !== lastRatingIndex-1" >
      </div>
    </v-app>
  </div>-->
</template>

<script>
export default {
  name: 'Rating',
  props: {
    'rating': Object,
    "ratingIndex": Number,
    "lastRatingIndex": Number,
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Rating.vue